export default __webpack_public_path__ + "static/media/eSiphala-Logo.d66ce68c.png";